import { Pipe, PipeTransform } from '@angular/core';
import { TravelItemMinimalWithVisibilityMetadata } from '../../api/models/travel-item-minimal-with-visibility-metadata';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { TravelService } from '../../api/services';
import { isBefore } from 'date-fns';
import { BookingItemMinimal, TravelDraftMinimal } from '../../api/models';

@Pipe({
  name: 'travelMenu',
  pure: true,
})
export class TravelMenuPipe implements PipeTransform {
  gmg_editable = isBefore(new Date(), new Date(2026, 3, 30));
  selectedTravel?: TravelDraftMinimal;
  selectedBookedTravel?: BookingItemMinimal;
  constructor(private router: Router) {}

  transform(
    travel:
      | TravelDraftMinimal
      | TravelItemMinimalWithVisibilityMetadata
      | BookingItemMinimal,
    confirmDelete?: Function,
    tryPublish?: Function,
  ): MenuItem[] {
    if (!('funding' in travel)) {
      // È un BOOKING
      return [
        {
          label: 'Gestione',
          icon: 'pi pi-th-large',

          command: () => {
            this.router.navigate([
              '/viaggi-di-gruppo/travel-management-user',
              travel.identifier,
            ]);
          },
        },
        {
          label: 'Annulla prenotazione',
          icon: 'pi pi-times',
          styleClass: 'red-text',
          command: () => {
            if (confirmDelete) {
              confirmDelete(travel.id);
            }
          },
        },
      ];
    }
    //E' UN TRAVEL
    return [
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible: !travel.draft && travel.funding && this.gmg_editable,
        command: () => {
          this.router.navigate([
            '/viaggi-di-gruppo/edit-travel-gmg',
            travel.id,
          ]);
        },
      },
      {
        label: 'Modifica',
        icon: 'pi pi-pencil',
        visible: travel.draft || !travel.funding,
        command: () => {
          this.router.navigate(['/viaggi-di-gruppo/edit-travel', travel.id]);
        },
      },
      {
        label: 'Gestione',
        icon: 'pi pi-th-large',
        visible: !travel.draft,
        command: () => {
          this.router.navigate([
            '/viaggi-di-gruppo/travel-management',
            travel.id,
          ]);
        },
      },
      {
        label: 'Pubblica',
        icon: 'pi pi-eye',
        visible: travel.draft && !!tryPublish,
        command: () => {
          if (tryPublish) {
            tryPublish(travel.id, travel);
          }
        },
      },
      {
        label: 'Invita',
        icon: 'pi pi-address-book',
        visible:
          !travel.draft && (travel.funding || travel.visibility?.id === 2),

        command: () => {
          this.router.navigate(['/user/address-book']);
        },
      },

      {
        label: 'Elimina',
        icon: 'pi pi-times',
        styleClass: 'red-text',
        visible: !!confirmDelete,
        command: () => {
          if (confirmDelete) {
            confirmDelete(travel.id);
          }
        },
      },
    ];
  }
}
